import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: "dashboard-edit",
    templateUrl: "./dashboard-edit.component.html",
    styleUrl: "./dashboard-edit.component.scss",
    standalone: false,
    host: { class: "wk-sde" },
})
export class DashboardEditComponent {
    bsModalRef = inject(BsModalRef);

    dashboard: any;
    title: string;
    loading: boolean;
    callback: Function;

    constructor() {}

    submitForm() {
        if (this.dashboard.Title.trim().length !== 0) {
            this.loading = true;
            this.callback(this.dashboard);
        }
    }
}
